export const degreeToRadian = (degree: number): number => {
  return (degree * Math.PI) / 180;
};

export const displacementBetween = (
  start: {
    lat: number;
    lon: number;
  },
  end: {
    lat: number;
    lon: number;
  }
): number => {
  const earthRadiusInM = 6371000;

  const latDistance = degreeToRadian(end.lat - start.lat);
  const lonDistance = degreeToRadian(end.lon - start.lon);

  const latOrigin = degreeToRadian(start.lat);
  const latDestination = degreeToRadian(end.lat);

  const a =
    Math.sin(latDistance / 2) * Math.sin(latDistance / 2) +
    Math.sin(lonDistance / 2) *
    Math.sin(lonDistance / 2) *
    Math.cos(latOrigin) *
    Math.cos(latDestination);

  const dist = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return Math.floor(earthRadiusInM * dist);
};

export const recursivelyEncodeShareURL = (obj: { [key: string]: any; }, { undo } = { undo: false }) => {
  if (!obj) return obj;
  const keys = ["car_data", "cheapest_cars", "most_popular_cars", "recommended_cars"];

  const hasBuffer = typeof Buffer !== "undefined";
  const encode = (s: string) =>
    hasBuffer ? Buffer.from(s, "utf8").toString("base64") : btoa(s);
  const decode = (s: string) =>
    hasBuffer ? Buffer.from(s, "base64").toString("utf8") : atob(s);

  keys.forEach((key) => {
    if (obj[key] && Array.isArray(obj[key])) {
      obj[key].forEach((element: any) => {
        if (element.shareURL && typeof element.shareURL === 'string') {
          element.shareURL = undo ? decode(element.shareURL) : encode(element.shareURL);
        }
      });
    }
  });

  return obj;
};
